import { render, staticRenderFns } from "./KgjtWebsiteBodyCheck.vue?vue&type=template&id=0c2b2eb3&scoped=true&"
import script from "./KgjtWebsiteBodyCheck.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteBodyCheck.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteBodyCheck.vue?vue&type=style&index=0&id=0c2b2eb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b2eb3",
  null
  
)

export default component.exports